import { render, staticRenderFns } from "./Solicitud_creditos.vue?vue&type=template&id=2a8dc864&"
import script from "./Solicitud_creditos.vue?vue&type=script&lang=ts&"
export * from "./Solicitud_creditos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports